import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  useEffect(() => {
    const previousTitle = document.title;
    const robots = document.querySelector('meta[name="robots"]');
    const previousRobots = robots?.getAttribute("content") || null;

    document.title = "Page Not Found — OITS Travel Together";
    if (robots) {
      robots.setAttribute("content", "noindex, nofollow");
    } else {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    }

    return () => {
      document.title = previousTitle;
      const currentRobots = document.querySelector('meta[name="robots"]');
      if (currentRobots) {
        if (previousRobots) currentRobots.setAttribute("content", previousRobots);
        else currentRobots.remove();
      }
    };
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <div className="text-xs uppercase tracking-widest text-accent mb-3">404</div>
      <h1 className="heading-serif text-5xl mb-5">Page not found</h1>
      <p className="text-muted-foreground leading-relaxed mb-8">
        This page is no longer available. Please return to OITS and explore our current journeys.
      </p>
      <Link
        to="/"
        className="inline-flex items-center rounded-md border border-border px-5 py-3 text-sm font-medium transition hover:bg-muted"
      >
        Back to OITS
      </Link>
    </div>
  );
}
